export default __webpack_public_path__ + "static/media/interactive4.4aaf8c84.svg";